/**
 * Vimeo Video Handler
 * Finds Vimeo links, creates hidden iframes in footer, and plays them in a custom overlay when links are clicked
 */

// Extract Vimeo video ID from URL
function getVimeoID(url) {
    const match = url.match(/(?:vimeo\.com\/|player\.vimeo\.com\/video\/)(\d+)/);
    return match ? match[1] : null;
}

export const vimeoVideos = () => {
    const vimeoLinks = document.querySelectorAll('a[href*="vimeo.com"]');
    
    if (vimeoLinks.length === 0) {
        return;
    }

    // Create a container in the footer for hidden iframes
    let iframeContainer = document.getElementById('vimeo-iframe-container');
    if (!iframeContainer) {
        iframeContainer = document.createElement('div');
        iframeContainer.id = 'vimeo-iframe-container';
        iframeContainer.style.display = 'none';
        iframeContainer.style.position = 'absolute';
        iframeContainer.style.left = '-9999px';
        document.body.appendChild(iframeContainer);
    }

    // Create custom overlay/modal
    let overlay = document.getElementById('vimeo-video-overlay');
    if (!overlay) {
        overlay = document.createElement('div');
        overlay.id = 'vimeo-video-overlay';
        overlay.style.cssText = `
            display: none;
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.9);
            z-index: 9999;
            align-items: center;
            justify-content: center;
        `;
        
        // Create close button
        const closeBtn = document.createElement('button');
        closeBtn.innerHTML = '×';
        closeBtn.style.cssText = `
            position: absolute;
            top: 20px;
            right: 20px;
            border: none;
            color: white;
            font-size: 40px;
            width: 50px;
            height: 50px;
            border-radius: 50%;
            cursor: pointer;
            z-index: 10000;
            transition: background 0.3s;
        `;
        overlay.appendChild(closeBtn);
        
        // Create video container
        const videoContainer = document.createElement('div');
        videoContainer.id = 'vimeo-video-container';
        videoContainer.style.cssText = `
            position: relative;
            width: 90%;
            max-width: 1280px;
            padding-bottom: 56.25%; /* 16:9 aspect ratio */
            height: 0;
        `;
        overlay.appendChild(videoContainer);
        
        document.body.appendChild(overlay);
        
        // Close on button click
        closeBtn.addEventListener('click', () => {
            closeVideo();
        });
        
        // Close on overlay click (but not on video container)
        overlay.addEventListener('click', (e) => {
            if (e.target === overlay) {
                closeVideo();
            }
        });
        
        // Close on Escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && overlay.style.display !== 'none') {
                closeVideo();
            }
        });
    }

    const videoContainer = document.getElementById('vimeo-video-container');
    const iframeMap = new Map();

    // Function to close the video overlay
    function closeVideo() {
        overlay.style.display = 'none';
        // Clear the video container
        videoContainer.innerHTML = '';
        // Stop any playing videos by removing iframes
        const iframes = iframeContainer.querySelectorAll('iframe');
        iframes.forEach(iframe => {
            iframe.src = '';
        });
    }

    vimeoLinks.forEach((link, index) => {
        const originalUrl = link.getAttribute('href');
        const videoID = getVimeoID(originalUrl);
        
        if (!videoID) {
            return;
        }

        // Store the video ID
        iframeMap.set(link, videoID);
        
        // Update the original link to open the video
        link.addEventListener('click', (e) => {
            e.preventDefault();
            
            // Create iframe with unmuted autoplay (user interaction allows this)
            const embedUrl = `https://player.vimeo.com/video/${videoID}?autoplay=0&muted=0&title=0&byline=0&portrait=0`;
            
            const iframe = document.createElement('iframe');
            iframe.src = embedUrl;
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
            iframe.setAttribute('allowfullscreen', '');
            iframe.style.cssText = `
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            `;
            
            // Clear container and add new iframe
            videoContainer.innerHTML = '';
            videoContainer.appendChild(iframe);
            
            // Show overlay
            overlay.style.display = 'flex';
        });
    });
};

